// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5b8820a5","79":"4e9763d2","511":"cd023e9e","606":"ca1c6866","663":"87a6516f","746":"1d13b274","929":"286f8d0c","980":"86fde8fe"}[chunkId] + ".chunk.js";
};